import { gql } from '@lojinha/palantir'

export const GET_MY_PURCHASES = gql`
  query GetMyPurchases {
    viewer {
      user {
        id
        sales {
          nodes {
            createdAt
            deliveryStatus
            order
            paymentStatus
            cart {
              deliverySettings {
                chosenDate
                chosenPeriod {
                  timeRange
                  name
                }
              }
              billing {
                total
                paymentMethod {
                  __typename
                  ... on CartBillingPaymentMethodPix {
                    type
                    qrCode
                    qrCodeUrl
                    expiresAt
                  }
                  ... on CartBillingPaymentMethodBoleto {
                    type
                    boletoUrl
                    boletoLine
                  }
                  ... on CartBillingPaymentMethodOffline {
                    type
                    brand
                  }
                  ... on CartBillingPaymentMethodOnline {
                    type
                    brand
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
